// Path: client\src\tutorials\listOfPlaygroundListsTutorialSteps.js
const listOfPlaygroundListsTutorialSteps = [
    {
      element: "#edit-button",
      intro: "Click this button to edit a checklist.",
      position: "left",
    },
    {
      element: "#delete-button",
      intro: "Click this button to delete a checklist.",
      position: "left",
    },
  ];
  
  export default listOfPlaygroundListsTutorialSteps;
  